import type { IInjectorModule } from "@paperbits/common/injection/IInjectorModule";
import { JobSearchCardRuntime } from "./jobSearchCard-runtime";

export class JobSearchCardRuntimeModule implements IInjectorModule {
    public register(): void {
        customElements.define('job-search-card-runtime', JobSearchCardRuntime);
    }
}